import { Component, HostListener, OnInit } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-pos-access-code",
	templateUrl: "./pos-access-code.component.html",
	styleUrls: ["./../pos.scss"],
})
export class PosAccessCodeComponent implements OnInit {
	accessCodeEntered: string = "";

	maxAccessCodeLength: number;
	constructor(public posService: PosService) {}

	@HostListener("document:keyup", ["$event"])
	handleKeyboardInput(event: any) {
		if (!isNaN(+event.key)) {
			if (this.accessCodeEntered.length < this.maxAccessCodeLength) {
				this.addCode(+event.key);
			}
		}
		if (event.key === "Enter") {
			this.logIn();
		}
		if (event.key === "Backspace") {
			this.accessCodeEntered = this.accessCodeEntered.slice(0, -1);
		}
	}

	ngOnInit(): void {
		this.posService.venueCoreConfig.subscribe((data) => {
			if (data.venueKey === this.posService.venueService.venueKey) {
				this.maxAccessCodeLength = data.MiscGeneral.AccessCodeLength;
			}
		});
	}

	addCode(val: number) {
		this.accessCodeEntered += val.toString();
		if (this.accessCodeEntered.length === this.maxAccessCodeLength) {
			this.logIn();
		}
	}

	clearCode() {
		this.accessCodeEntered = "";
	}

	logIn() {
		if (!this.accessCodeEntered) {
			this.posService.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Access code required.` });
		} else {
			this.posService.logInEmployee(this.accessCodeEntered);
		}
	}
}
